import dayjs from 'dayjs';
import _at from 'lodash/at';

export { listSort };

function listSort(items, { sortBy, sortDirection, caseInsensitive }) {
    return [...items].sort((a, b) => {
        let dir = sortDirection === 'DESC' ? 1 : -1;
        let aVal = _at(a, sortBy)[0];
        let bVal = _at(b, sortBy)[0];

        if (aVal == null) return -dir;
        if (bVal == null) return dir;

        if (dayjs(new Date(aVal)).isValid() || dayjs(new Date(bVal)).isValid()) {
            return dayjs(new Date(aVal)).isBefore(dayjs(new Date(bVal))) ? dir : -dir;
        }

        if (caseInsensitive) return aVal.toLowerCase() < bVal.toLowerCase() ? dir : -dir;

        return aVal < bVal ? dir : -dir;
    });
}
